import React, {useMemo} from "react";
import {useHtmlClassService} from "../../../_metronic/layout/_core/MetronicLayout";
import config from "../../../settings"

export function Footer() {
  const developPeriod = "2021";
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white p-8 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-left">
          <span className="text-muted font-weight-bold mr-2">{developPeriod}</span> &copy;{" "} VIVI energia
        </div>

        <div className="text-center ml-14">
          <span>Built with <span role='img' aria-label='love'>❤️</span> in Italy</span>
        </div>
        
        <div className="text-right">
          <a title="What's new" target="blank" href={config.relNotesUrl}>
            <span>Version {config.version} {(config.environment !== "Production") ? "(" + config.environment + ")" : ""}</span>
          </a>
        </div>

      </div>
    </div>
  );
}
